import { useTranslation } from 'react-i18next';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { call } from '@spacefill/shared/src/utils/Backend';
import { Button } from '@spacefill/uikit/src/components/Button/Button';
import { Chip } from '@spacefill/uikit/src/components/Chip/Chip';

export function AnnouncementsBanner() {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    const { data } = useQuery({
        queryKey: ['/in-app-notifications/list-announcements', 'readStatus'],
        queryFn: () => call('/in-app-notifications/list-announcements', { readStatus: 'unread' }),
        refetchOnWindowFocus: true,
        staleTime: 1000 * 60 * 10,
        refetchInterval: 1000 * 60 * 10,
    });

    const unreadAnnouncements = data?.data || [];

    const { mutate: markAsRead } = useMutation({
        mutationFn: (id) => call(`/in-app-notifications/${id}/read`, {}, 'POST'),
        onSuccess() {
            queryClient.invalidateQueries({ queryKey: ['/in-app-notifications/list-announcements'] });
        },
    });

    if (unreadAnnouncements.length === 0) {
        return null;
    }

    const latestAnnouncement = unreadAnnouncements[0];
    if (!latestAnnouncement?.templateParams?.announcement) return null;
    const { title, content, creatorName } = latestAnnouncement.templateParams.announcement;

    const handleClose = () => {
        markAsRead(latestAnnouncement.id);
    };

    return (
        <div className='flex w-full items-center justify-between bg-blue-100 py-3 px-6'>
            <div className='flex-1 text-left text-sm bg-transparent border-none transition-colors'>
                <div className='font-semibold mb-2'>
                    {title}{' '}
                    <Chip
                        variant='normal'
                        className='bg-white/20'
                    >
                        {t('New announcement')}
                    </Chip>
                </div>
                <div className='mb-2'>{content}</div>
                <p className='opacity-70'>{t('By {{person}}', { person: creatorName })}</p>
            </div>

            <Button
                variant='outlined'
                onClick={handleClose}
                className='ml-4'
            >
                {t('Got it!')}
            </Button>
        </div>
    );
}
